import React from 'react';
import styled from 'styled-components';
import Icon from '@airasia/phoenix-components/components/Icon';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import { bool, string, func, oneOfType, element } from 'prop-types';
import { BodyText, CaptionText } from '../Text/Heading';
import Row from '../Container/Row';
import Wrapper from '../Wrapper';

const HeaderWrapper = styled(Row)`
  height: 56px;
  align-items: center;
  top: 0;
  width: 100%;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  background-color: ${({ theme }) => theme.colors.default};
  position: fixed;
  z-index: 10;
`;
HeaderWrapper.defaultProps = {
  display: ['flex', 'none'],
};

const LeftIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  margin: 16px;
  color: ${({ theme }) => theme.colors.greyDark};
`;

const RightIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.greyDark};
`;

LeftIcon.displayName = 'LeftIcon';

const RightItemWrapper = styled(Row)`
  margin: 16px;
  justify-content: flex-end;
`;

const TextWrapper = styled(Row)`
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

const DestinationText = styled(BodyText)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  line-height: 18px;
  font-size: 14px;
  max-width: ${({ showDate }) => (showDate ? '100%' : 'calc(100% - 100px)')};
`;

const EditableMobileNavHeader = ({
  date,
  dest,
  guest,
  room,
  onClickBack,
  onClickEditSearch,
  showDateInSubtitle,
  className,
  rightItem,
}) => {
  return (
    <PhoenixTheme>
      <HeaderWrapper className={className}>
        <Wrapper onClick={onClickBack} className="mobile-back-button">
          <LeftIcon icon="ArrowBackIcon" fontsize="titleNormal" />
        </Wrapper>
        <TextWrapper onClick={onClickEditSearch}>
          <Wrapper className="mobile-header-title" display="flex" mb="3px">
            <DestinationText showDate={showDateInSubtitle}>
              {dest}
            </DestinationText>
            {!showDateInSubtitle && (
              <>
                <BodyText
                  fontWeight={500}
                  lineHeight="18px"
                  fontSize={14}
                  mr={2}
                >
                  ,
                </BodyText>
                <CaptionText fontWeight={500} lineHeight="18px" fontSize={12}>
                  {date}
                </CaptionText>
              </>
            )}
          </Wrapper>
          <CaptionText
            className="mobile-header-subtitle"
            lineHeight="16px"
            fontSize={12}
            whiteSpace="break-spaces"
          >
            {showDateInSubtitle && `${date} | `}
            {`${guest}  |  ${room}`}
          </CaptionText>
        </TextWrapper>
        <Wrapper
          onClick={onClickEditSearch}
          className="mobile-edit-button"
          margin={rightItem ? 0 : 16}
        >
          <RightIcon icon="EditIcon" fontsize="titleNormal" />
        </Wrapper>
        {rightItem && <RightItemWrapper>{rightItem}</RightItemWrapper>}
      </HeaderWrapper>
    </PhoenixTheme>
  );
};

EditableMobileNavHeader.propTypes = {
  date: oneOfType([string, element]),
  dest: oneOfType([string, element]),
  guest: oneOfType([string, element]),
  room: oneOfType([string, element]),
  onClickEditSearch: func,
  onClickBack: func,
  className: string,
  rightItem: element,
  editSearchUrl: string,
  showDateInSubtitle: bool,
};

export default EditableMobileNavHeader;
